module.exports = __webpack_public_path__ + "img/viagem-chile.f59be651.jpeg";